<template>
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path
            d="M9.56055 6.13184L12.3486 3.34375L14.2754 5.27051L11.5098 8.03516H15.4004L15.3994 10.7598H11.5078L14.2754 13.5273L12.3486 15.4541L9.56055 12.666V16.5996H6.83594V12.709L4.09277 15.4521L2.16602 13.5264L4.93262 10.7598H1V8.03516H4.92969L2.16602 5.27148L4.09277 3.34473L6.83594 6.08789V2.19922H9.56055V6.13184Z"
            fill="currentColor" />
    </svg>
</template>
